import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class ClientIdServiceService {
    clientId = signal<number | null>(null);
    hsId = signal<number | null>(null);
}